(function () {'use strict';}());
angular.module("elidb").directive('tooltipContainer', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/tooltip.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        var service;

        $scope.$watch("currentTooltip",onTooltipSet);
        $scope.$watch("currentHint",onHintSet);

        function onTooltipSet(value){
          service = value;

          if(value === undefined || value === null) {
            //$scope.tooltip = $scope.top = $scope.left = null;
            return;
          }

//          trace("on tooltips set",value);

          var target = $("#tag-container-"+value.id).find("label");
          var offset = target.offset();
          var width = target.width();
      //    trace(target);
          $scope.tooltip = value.tooltip;
          $scope.service = value.label;
          $scope.top = offset.top;
          $scope.left = offset.left + width + 5;

          $timeout(checkBounds,100);

        }

        function onHintSet(value) {
          if(value === undefined || value === null) {
            //$scope.tooltip = $scope.top = $scope.left = null;
            return;
          }

          //trace("on hint set");

          var target = $(value.selector);
          var offset = target.offset();
          var width = target.width();
          $scope.tooltip = value.tooltip;
          $scope.service = value.label;
          $scope.top = offset.top + target.height() + 25;
          $scope.left = offset.left + width/2 + 5;

          $document.on("click",hideHint);
        }

        function hideHint(){
          $scope.$apply(function(){
            $scope.setCurrentHint(null,null);
          });
          
          $document.off("click",hideHint);
        } 

        function checkBounds(){
          var tooltip = $(".tooltip").get(0).getBoundingClientRect();
          var container = $("#tooltip-container").get(0).getBoundingClientRect();
          if(tooltip.top + 165 > container.bottom) $scope.top = container.bottom - 175;
        }
       	
      }  
    };
  });